const initMercaveloProduct = () => {
  const items = document.querySelectorAll('.mv-product-reveal');
  if (!items.length) return;

  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reducedMotion || !('IntersectionObserver' in window)) {
    items.forEach((item) => item.classList.add('is-visible'));
    return;
  }

  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (!entry.isIntersecting) return;
      entry.target.classList.add('is-visible');
      observer.unobserve(entry.target);
    });
  }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });

  items.forEach((item) => observer.observe(item));
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initMercaveloProduct, { once: true });
} else {
  initMercaveloProduct();
}

document.addEventListener('shopify:section:load', initMercaveloProduct);
